// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SingleValueChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SingleValueChartIcon" ref={forwardedRef} {...props}>
      <path d="M2 4h1.5v11.498H18V17H3a1 1 0 0 1-1-1z" />
      <path d="M5.835 13.209a4.2 4.2 0 0 1-1.237-.723l.759-1.156a3.4 3.4 0 0 0 .867.488 2.5 2.5 0 0 0 .903.171 1.6 1.6 0 0 0 .65-.126A1 1 0 0 0 8.22 11.51a.9.9 0 0 0 .162-.533c0-.262-.108-.47-.334-.641-.217-.163-.506-.253-.858-.271-.126 0-.244 0-.37.018-.127.018-.244.054-.361.09L5.69 8.946l2.033-1.644H5.05V5.686h4.714v1.607L7.677 8.91a3 3 0 0 1 .181 0 2.2 2.2 0 0 1 1.093.28A2 2 0 0 1 9.72 9.94a2.2 2.2 0 0 1 .289 1.12c0 .478-.118.902-.361 1.263a2.37 2.37 0 0 1-.985.85 3.3 3.3 0 0 1-1.419.297 3.9 3.9 0 0 1-1.4-.252z" />
      <path d="m13.818 8.11 1.1-.352v4.022h-1.21v1.591h3.89V11.78h-1.12V5.785h-1.14l-1.94 1.24z" />
      <path d="M10.647 12.405c0 .289.082.524.262.704q.268.27.714.271c.28 0 .506-.1.695-.28a.92.92 0 0 0 .28-.695 1 1 0 0 0-.28-.705c-.18-.19-.397-.28-.695-.28s-.533.09-.714.28a1 1 0 0 0-.262.705" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SingleValueChartIcon = /* @__PURE__ */ Object.assign(
  SingleValueChartIconComponent,
  { displayName: 'SingleValueChartIcon' },
);
